// /* eslint-disable array-callback-return */
// import React, { forwardRef, useEffect, useRef, useState, createContext, useContext } from "react";
// import { useDispatch } from 'react-redux';
// import PrintIcon from '@mui/icons-material/Print';
// import { IconButton } from "@mui/material";
// import ReactToPrint from "react-to-print";
// import { genHardCopyTestFormByResvcode } from '../store/TestMgmtSlice';

// /*------------- Function Component to be called by ToPrintPageBookTestDate-----------*/
// const FrmContext = createContext();
// const ComponentToPrint = forwardRef((props, ref) => {
//     const seltestfrm = useContext(FrmContext);
//     let formAB = seltestfrm.filter((el, index) => { return (index < 200) });
//     let formA = formAB.slice(0, 100);
//     let formB = formAB.slice(100, 200);

//     const contectBlockFunc = (form, _start, _end) => {
//         let l_frm = form.filter(
//             frm => { return (frm.questionorder >= _start && frm.questionorder <= _end) }
//         ).filter((q, i) => {
//             return (i < ((_end - _start) + 1) / 2)
//         });

//         let r_frm = form.filter(
//             frm => { return (frm.questionorder >= _start && frm.questionorder <= _end) }
//         ).filter((q, i) => {
//             return (i >= ((_end - _start) + 1) / 2)
//         });

//         return (
//             <div className="grid-container">
//                 <div>
//                     {
//                         l_frm.map((f, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{f.questionorder}.&nbsp;{
//                                         f['tbquestion.question'] === 'none' || f['tbquestion.question'].includes('mp3') ?
//                                             '' : f['tbquestion.question']
//                                     }</p>
//                                     <p className="indent">{'a)'}&nbsp;{f['fk_choiceA.choicetext']}</p>
//                                     <p className="indent">{'b)'}&nbsp;{f['fk_choiceB.choicetext']}</p>
//                                     <p className="indent">{'c)'}&nbsp;{f['fk_choiceC.choicetext']}</p>
//                                     <p className="indent">{'d)'}&nbsp;{f['fk_choiceD.choicetext']}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//                 <div>
//                     {
//                         r_frm.map((f, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{f.questionorder}.&nbsp;{
//                                         f['tbquestion.question'] === 'none' || f['tbquestion.question'].includes('mp3') ?
//                                             '' : f['tbquestion.question']
//                                     }</p>
//                                     <p className="indent">{'a)'}&nbsp;{f['fk_choiceA.choicetext']}</p>
//                                     <p className="indent">{'b)'}&nbsp;{f['fk_choiceB.choicetext']}</p>
//                                     <p className="indent">{'c)'}&nbsp;{f['fk_choiceC.choicetext']}</p>
//                                     <p className="indent">{'d)'}&nbsp;{f['fk_choiceD.choicetext']}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//             </div>
//         );
//     }//---> End of contectBlockFunc

//     const contectBlock67100Func = (form, _start, _end) => {
//         let l_frm = form.filter(
//             frm => { return (frm.questionorder >= _start && frm.questionorder <= _end) }
//         );

//         return (
//             <div className="flex-container">
//                 <div>
//                     {
//                         l_frm.map((f, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{f.questionorder}.&nbsp;{
//                                         f['tbquestion.question'] === 'none' || f['tbquestion.question'].includes('mp3') ?
//                                             '' : f['tbquestion.question']
//                                     }</p>
//                                     <p className="indent">{'a)'}&nbsp;{f['fk_choiceA.choicetext']}</p>
//                                     <p className="indent">{'b)'}&nbsp;{f['fk_choiceB.choicetext']}</p>
//                                     <p className="indent">{'c)'}&nbsp;{f['fk_choiceC.choicetext']}</p>
//                                     <p className="indent">{'d)'}&nbsp;{f['fk_choiceD.choicetext']}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//             </div>
//         );
//     }//---> End of contectBlockFunc

//     const getAnswerFunc = (form) => {
//         let form_ans = form.map(eachquestion => {
//             if (eachquestion['fk_choiceA.answer'] === 1) {
//                 return ({
//                     'qnorder': eachquestion['questionorder'],
//                     'choice': 'A',
//                     'text': eachquestion['fk_choiceA.choicetext'],
//                 })
//             } else if (eachquestion['fk_choiceB.answer'] === 1) {
//                 return ({
//                     'qnorder': eachquestion['questionorder'],
//                     'choice': 'B',
//                     'text': eachquestion['fk_choiceB.choicetext'],
//                 })
//             } else if (eachquestion['fk_choiceC.answer'] === 1) {
//                 return ({
//                     'qnorder': eachquestion['questionorder'],
//                     'choice': 'C',
//                     'text': eachquestion['fk_choiceC.choicetext'],
//                 })
//             } else if (eachquestion['fk_choiceD.answer'] === 1) {
//                 return ({
//                     'qnorder': eachquestion['questionorder'],
//                     'choice': 'D',
//                     'text': eachquestion['fk_choiceD.choicetext'],
//                 })
//             }
//         });//--> map

//         let c1_ans = form_ans.filter((ans, i) => { return (i <= 19) });
//         let c2_ans = form_ans.filter((ans, i) => { return (i >= 20 && i <= 39) });
//         let c3_ans = form_ans.filter((ans, i) => { return (i >= 40 && i <= 59) });
//         let c4_ans = form_ans.filter((ans, i) => { return (i >= 60 && i <= 79) });
//         let c5_ans = form_ans.filter((ans, i) => { return (i >= 80) });

//         return (
//             <div className="grid-ans-container">
//                 <div>
//                     {
//                         c1_ans.map((ans, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{`${ans.qnorder}. ${ans.choice}`}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//                 <div>
//                     {
//                         c2_ans.map((ans, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{`${ans.qnorder}. ${ans.choice}`}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//                 <div>
//                     {
//                         c3_ans.map((ans, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{`${ans.qnorder}. ${ans.choice}`}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//                 <div>
//                     {
//                         c4_ans.map((ans, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{`${ans.qnorder}. ${ans.choice}`}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//                 <div>
//                     {
//                         c5_ans.map((ans, i) => {
//                             return (
//                                 <div key={i}>
//                                     <p>{`${ans.qnorder}. ${ans.choice}`}</p>
//                                     <br />
//                                 </div>
//                             )
//                         })
//                     }
//                 </div>
//             </div>
//         );
//     }

//     /*-------------------------- return ------------------*/
//     return (
//         <div ref={ref}>
//             {
//                 [formA, formB].map((frm, i) => {
//                     if (frm.length !== 0) {
//                         return (
//                             <div key={i}>
//                                 <div className="pagebreak" key={i}>
//                                     <p>AMERICAN LANGUAGE COURSE PLACEMENT TEST</p>
//                                     <br />
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     <p>PART I - LISTENING</p>
//                                     <br />
//                                     <p>Directions for items 1-56. You will hear statements or
//                                         questions on the tape. Select the best answer and mark your
//                                         answer sheet, a, b, c, or d. DO NOT WRITE ON THE TEST BOOKLET.</p>
//                                     <br />
//                                     {
//                                         contectBlockFunc(frm, 1, 10)
//                                     }

//                                 </div>
//                                 <div className="pagebreak" key={i + 1}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlockFunc(frm, 11, 22)
//                                     }
//                                 </div>
//                                 <div className="pagebreak" key={i + 2}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlockFunc(frm, 23, 34)
//                                     }
//                                 </div>
//                                 <div className="pagebreak" key={i + 3}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlockFunc(frm, 35, 46)
//                                     }
//                                 </div>
//                                 <div className="pagebreak" key={i + 4}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlockFunc(frm, 47, 56)
//                                     }
//                                 </div>
//                                 <div className="pagebreak" key={i + 5}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     <p>Directions for items 57-66. You will hear conversations or persons giving information. Select the best answer and mark your answer sheet, a, b, c, or d.</p>
//                                     <br />
//                                     {
//                                         contectBlockFunc(frm, 57, 66)
//                                     }
//                                     <p>THIS IS THE END OF THE LISTENING PART OF THE TEST.</p>
//                                 </div>
//                                 <div className="pagebreak" key={i + 6}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <p>PART II - READING</p>
//                                     <br />
//                                     <p>Directions for items 67-100. Select the best answer and mark your answer sheet, a, b, c, or d. DO NOT WRITE ON THE TEST BOOKLET.</p>
//                                     <br />
//                                     {
//                                         contectBlock67100Func(frm, 67, 71)
//                                     }
//                                 </div>
//                                 <div className="pagebreak" key={i + 7}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlock67100Func(frm, 72, 77)
//                                     }
//                                 </div>
//                                 <div className="pagebreak" key={i + 8}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlock67100Func(frm, 78, 83)
//                                     }
//                                 </div>
//                                 <div className="pagebreak" key={i + 9}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlock67100Func(frm, 84, 89)
//                                     }
//                                     <br />
//                                 </div>
//                                 <div className="pagebreak" key={i + 10}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlock67100Func(frm, 90, 95)
//                                     }
//                                     <br />
//                                 </div>
//                                 <div className="pagebreak" key={i + 11}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
//                                     <br />
//                                     {
//                                         contectBlock67100Func(frm, 96, 100)
//                                     }
//                                     <br />
//                                     <p>THIS IS THE END OF THE TEST.</p>
//                                 </div>
//                                 <div className="pagebreak" key={i + 12}>
//                                     <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))} : ANSWER</p>
//                                     <br />
//                                     {
//                                         getAnswerFunc(frm)
//                                     }
//                                 </div>
//                             </div>
//                         )//---> end of return
//                     } else {
//                         return ([])
//                     }
//                 })
//             }
//         </div>
//     );
// });

// /*------------- Function Component to be called as child component -----------*/
// const ComponentToPrintWrapper = ({ item }) => {
//     // console.log('item ===> ', item)
//     const componentRef = useRef();
//     const promiseRef = useRef(null);
//     const [seltestfrm, setSelTestFrm] = useState([]);
//     const [selresvcode, setSelResvCode] = useState('');

//     useEffect(() => {
//         document.getElementById(`${item}`).addEventListener('click', () => {
//             setSelResvCode(item);
//         });
//     }, [setSelResvCode, item]);

//     useEffect(() => {
//         if (promiseRef.current && seltestfrm.length !== 0) {
//             promiseRef.current();
//         }
//     }, [seltestfrm]);

//     const dispatch = useDispatch();
//     return (
//         <FrmContext.Provider value={seltestfrm}>
//             <ReactToPrint
//                 trigger={() =>
//                     <IconButton color="primary" id={item}>
//                         <PrintIcon sx={{ color: '#1976D2' }} />
//                     </IconButton>
//                 }
//                 content={() => componentRef.current}
//                 pageStyle={() => {
//                     const marginTop = '1.5cm';
//                     const marginRight = '0.5cm';
//                     const marginBottom = '1cm';
//                     const marginLeft = '1cm';

//                     return (`
//                       @media print {
//                         .pagebreak { 
//                            page-break-before: always; 
//                         }
//                         .grid-container {
//                             display: grid;
//                             grid-template-columns: repeat(2, 1fr);
//                             column-gap: 2rem;
//                             row-gap: 1rem;
//                         }
//                         .grid-ans-container {
//                             display: grid;
//                             grid-template-columns: repeat(5, 1fr);
//                             column-gap: 1rem;
//                             row-gap: 1rem;
//                         }
//                         .indent {
//                             text-indent: 10%;
//                         }
//                         .flex-container {
//                             display: flex;
//                             flex-direction: row;
//                         }
//                       }
//                       @page {
//                           size: A4 portrait;
//                           margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;
//                       }
//                   `);
//                 }}
//                 onBeforeGetContent={() => {
//                     return new Promise((resolve) => {
//                         dispatch(genHardCopyTestFormByResvcode(
//                             { 'resvcode': selresvcode }
//                         )).then(res => {
//                             setSelTestFrm(res.payload);
//                         });
//                         promiseRef.current = resolve;
//                     })
//                 }}
//             />
//             <div style={{ display: 'none' }}>
//                 <ComponentToPrint ref={componentRef} />
//             </div>
//         </FrmContext.Provider>
//     );
// }

// export default ComponentToPrintWrapper;




import React, { forwardRef, useMemo, useEffect, useRef, useState, createContext, useContext } from "react";
import { useDispatch } from 'react-redux';
import PrintIcon from '@mui/icons-material/Print';
import { IconButton } from "@mui/material";
import ReactToPrint from "react-to-print";
import { genHardCopyTestFormByResvcode } from '../store/TestMgmtSlice';

/*------------- Function Component to be called by ToPrintPageBookTestDate-----------*/
const FrmContext = createContext();
const ComponentToPrint = forwardRef((props, ref) => {
    const seltestfrm = useContext(FrmContext);
    let formAB = seltestfrm.filter((el, index) => { return (index < 200) });
    let formA = formAB.slice(0, 100);
    let formB = formAB.slice(100, 200);

    const contectBlockFunc = (form, _start, _end) => {
        let l_frm = form.filter(
            frm => { return (frm.questionorder >= _start && frm.questionorder <= _end) }
        ).filter((q, i) => {
            return (i < ((_end - _start) + 1) / 2)
        });

        let r_frm = form.filter(
            frm => { return (frm.questionorder >= _start && frm.questionorder <= _end) }
        ).filter((q, i) => {
            return (i >= ((_end - _start) + 1) / 2)
        });

        return (
            <div className="grid-container">
                <div>
                    {
                        l_frm.map((f, i) => {
                            return (
                                <div key={i}>
                                    <p>{f.questionorder}.&nbsp;{
                                        f['tbquestion.question'] === 'none' || f['tbquestion.question'].includes('mp3') ?
                                            '' : f['tbquestion.question']
                                    }</p>
                                    <p className="indent">{'a)'}&nbsp;{f['fk_choiceA.choicetext']}</p>
                                    <p className="indent">{'b)'}&nbsp;{f['fk_choiceB.choicetext']}</p>
                                    <p className="indent">{'c)'}&nbsp;{f['fk_choiceC.choicetext']}</p>
                                    <p className="indent">{'d)'}&nbsp;{f['fk_choiceD.choicetext']}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
                <div>
                    {
                        r_frm.map((f, i) => {
                            return (
                                <div key={i}>
                                    <p>{f.questionorder}.&nbsp;{
                                        f['tbquestion.question'] === 'none' || f['tbquestion.question'].includes('mp3') ?
                                            '' : f['tbquestion.question']
                                    }</p>
                                    <p className="indent">{'a)'}&nbsp;{f['fk_choiceA.choicetext']}</p>
                                    <p className="indent">{'b)'}&nbsp;{f['fk_choiceB.choicetext']}</p>
                                    <p className="indent">{'c)'}&nbsp;{f['fk_choiceC.choicetext']}</p>
                                    <p className="indent">{'d)'}&nbsp;{f['fk_choiceD.choicetext']}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }//---> End of contectBlockFunc

    const contectBlock67100Func = (form, _start, _end) => {
        let l_frm = form.filter(
            frm => { return (frm.questionorder >= _start && frm.questionorder <= _end) }
        );

        return (
            <div className="flex-container">
                <div>
                    {
                        l_frm.map((f, i) => {
                            return (
                                <div key={i}>
                                    <p>{f.questionorder}.&nbsp;{
                                        f['tbquestion.question'] === 'none' || f['tbquestion.question'].includes('mp3') ?
                                            '' : f['tbquestion.question']
                                    }</p>
                                    <p className="indent">{'a)'}&nbsp;{f['fk_choiceA.choicetext']}</p>
                                    <p className="indent">{'b)'}&nbsp;{f['fk_choiceB.choicetext']}</p>
                                    <p className="indent">{'c)'}&nbsp;{f['fk_choiceC.choicetext']}</p>
                                    <p className="indent">{'d)'}&nbsp;{f['fk_choiceD.choicetext']}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }//---> End of contectBlockFunc

    const getAnswerFunc = (form) => {
        let form_ans = form.map(eachquestion => {
            if (eachquestion['fk_choiceA.answer'] === 1) {
                return ({
                    'qnorder': eachquestion['questionorder'],
                    'choice': 'A',
                    'text': eachquestion['fk_choiceA.choicetext'],
                })
            } else if (eachquestion['fk_choiceB.answer'] === 1) {
                return ({
                    'qnorder': eachquestion['questionorder'],
                    'choice': 'B',
                    'text': eachquestion['fk_choiceB.choicetext'],
                })
            } else if (eachquestion['fk_choiceC.answer'] === 1) {
                return ({
                    'qnorder': eachquestion['questionorder'],
                    'choice': 'C',
                    'text': eachquestion['fk_choiceC.choicetext'],
                })
            } else if (eachquestion['fk_choiceD.answer'] === 1) {
                return ({
                    'qnorder': eachquestion['questionorder'],
                    'choice': 'D',
                    'text': eachquestion['fk_choiceD.choicetext'],
                })
            }
        });//--> map

        let c1_ans = form_ans.filter((ans, i) => { return (i <= 19) });
        let c2_ans = form_ans.filter((ans, i) => { return (i >= 20 && i <= 39) });
        let c3_ans = form_ans.filter((ans, i) => { return (i >= 40 && i <= 59) });
        let c4_ans = form_ans.filter((ans, i) => { return (i >= 60 && i <= 79) });
        let c5_ans = form_ans.filter((ans, i) => { return (i >= 80) });

        return (
            <div className="grid-ans-container">
                <div>
                    {
                        c1_ans.map((ans, i) => {
                            return (
                                <div key={i}>
                                    <p>{`${ans.qnorder}. ${ans.choice}`}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
                <div>
                    {
                        c2_ans.map((ans, i) => {
                            return (
                                <div key={i}>
                                    <p>{`${ans.qnorder}. ${ans.choice}`}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
                <div>
                    {
                        c3_ans.map((ans, i) => {
                            return (
                                <div key={i}>
                                    <p>{`${ans.qnorder}. ${ans.choice}`}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
                <div>
                    {
                        c4_ans.map((ans, i) => {
                            return (
                                <div key={i}>
                                    <p>{`${ans.qnorder}. ${ans.choice}`}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
                <div>
                    {
                        c5_ans.map((ans, i) => {
                            return (
                                <div key={i}>
                                    <p>{`${ans.qnorder}. ${ans.choice}`}</p>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }

    /*-------------------------- return ------------------*/
    return (
        <div ref={ref}>
            {
                [formA, formB].map((frm, i) => {
                    if (frm.length !== 0) {
                        return (
                            <div key={i}>
                                <div className="pagebreak" key={i}>
                                    <p>AMERICAN LANGUAGE COURSE PLACEMENT TEST</p>
                                    <br />
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    <p>PART I - LISTENING</p>
                                    <br />
                                    <p>Directions for items 1-56. You will hear statements or
                                        questions on the tape. Select the best answer and mark your
                                        answer sheet, a, b, c, or d. DO NOT WRITE ON THE TEST BOOKLET.</p>
                                    <br />
                                    {
                                        contectBlockFunc(frm, 1, 10)
                                    }

                                </div>
                                <div className="pagebreak" key={i + 1}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlockFunc(frm, 11, 22)
                                    }
                                </div>
                                <div className="pagebreak" key={i + 2}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlockFunc(frm, 23, 34)
                                    }
                                </div>
                                <div className="pagebreak" key={i + 3}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlockFunc(frm, 35, 46)
                                    }
                                </div>
                                <div className="pagebreak" key={i + 4}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlockFunc(frm, 47, 56)
                                    }
                                </div>
                                <div className="pagebreak" key={i + 5}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    <p>Directions for items 57-66. You will hear conversations or persons giving information. Select the best answer and mark your answer sheet, a, b, c, or d.</p>
                                    <br />
                                    {
                                        contectBlockFunc(frm, 57, 66)
                                    }
                                    <p>THIS IS THE END OF THE LISTENING PART OF THE TEST.</p>
                                </div>
                                <div className="pagebreak" key={i + 6}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <p>PART II - READING</p>
                                    <br />
                                    <p>Directions for items 67-100. Select the best answer and mark your answer sheet, a, b, c, or d. DO NOT WRITE ON THE TEST BOOKLET.</p>
                                    <br />
                                    {
                                        contectBlock67100Func(frm, 67, 71)
                                    }
                                </div>
                                <div className="pagebreak" key={i + 7}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlock67100Func(frm, 72, 77)
                                    }
                                </div>
                                <div className="pagebreak" key={i + 8}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlock67100Func(frm, 78, 83)
                                    }
                                </div>
                                <div className="pagebreak" key={i + 9}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlock67100Func(frm, 84, 89)
                                    }
                                    <br />
                                </div>
                                <div className="pagebreak" key={i + 10}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlock67100Func(frm, 90, 95)
                                    }
                                    <br />
                                </div>
                                <div className="pagebreak" key={i + 11}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))}</p>
                                    <br />
                                    {
                                        contectBlock67100Func(frm, 96, 100)
                                    }
                                    <br />
                                    <p>THIS IS THE END OF THE TEST.</p>
                                </div>
                                <div className="pagebreak" key={i + 12}>
                                    <p>FORM {parseInt(seltestfrm[0]?.question_code.substring(1, 5))} : ANSWER</p>
                                    <br />
                                    {
                                        getAnswerFunc(frm)
                                    }
                                </div>
                            </div>
                        )//---> end of return
                    } else {
                        return ([])
                    }
                })
            }
        </div>
    );
});

/*------------- Function Component to be called as child component -----------*/
const ComponentToPrintWrapper = ({ item, selfrm }) => {
    const componentRef = useRef();
    const promiseRef = useRef(null);
    const [seltestfrm, setSelTestFrm] = useState([]);
    const [selresvcode, setSelResvCode] = useState('');
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        document.getElementById(`${item[1]}`).addEventListener('click', () => {
            setSelResvCode(item[1]);
        });
    }, [setSelResvCode, item[1]]);

    useEffect(() => {
        if (promiseRef.current && seltestfrm.length !== 0) {
            promiseRef.current();
        }
    }, [seltestfrm]);

    useMemo(() => {
        setDisabled((item[7].includes('APRV') && selfrm > 0) ? false : true);
    }, [selfrm])

    const dispatch = useDispatch();
    return (
        <FrmContext.Provider value={seltestfrm}>
            <ReactToPrint
                trigger={() =>
                    <IconButton
                        color="primary"
                        id={item[1]}
                        disabled={disabled}
                    >
                        <PrintIcon sx={{
                            color : !disabled ? '#1976D2' : 'gray'
                        }} />
                    </IconButton>
                }
                content={() => componentRef.current}
                pageStyle={() => {
                    const marginTop = '1.5cm';
                    const marginRight = '0.5cm';
                    const marginBottom = '1cm';
                    const marginLeft = '1cm';

                    return (`
                      @media print {
                        .pagebreak { 
                           page-break-before: always; 
                        }
                        .grid-container {
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            column-gap: 2rem;
                            row-gap: 1rem;
                        }
                        .grid-ans-container {
                            display: grid;
                            grid-template-columns: repeat(5, 1fr);
                            column-gap: 1rem;
                            row-gap: 1rem;
                        }
                        .indent {
                            text-indent: 10%;
                        }
                        .flex-container {
                            display: flex;
                            flex-direction: row;
                        }
                      }
                      @page {
                          size: A4 portrait;
                          margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;
                      }
                  `);
                }}
                onBeforeGetContent={() => {
                    return new Promise((resolve) => {
                        dispatch(genHardCopyTestFormByResvcode(
                            { 'resvcode': selresvcode }
                        )).then(res => {
                            setSelTestFrm(res.payload);
                        });
                        promiseRef.current = resolve;
                    })
                }}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrint ref={componentRef} />
            </div>
        </FrmContext.Provider>
    );
}

export default ComponentToPrintWrapper;